










































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { countries } from '../Commons/phone-code-countries';
import GDPR from './GDPR.vue';
import ReCaptcha from '../../components/ReCaptcha/ReCaptcha.vue';
declare var window: any;

@Component({
  components: { GDPR, ReCaptcha },
})
export default class SignupForm extends Vue {
  private confirmPassword: string = '';
  private showPassword = false;
  private candidatePhone: string = '';
  private countryCode: string = '';
  private translations = {
    countrySelectorLabel: null,
    countrySelectorError: null,
    phoneNumberLabel: null,
    example: null,
  };
  private isGDPREnabled: boolean = true;
  private noExample: boolean = true;
  private noFlags: boolean = true;
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  @Prop() register;
  @Prop() wlUser;
  @Prop() errors;
  @Prop() socialRegistration;
  @Prop() isEmailSystemGenerated;
  $toastr: any;

  private recaptchaSizeValue: string = vxm.utility.isVisibleReCaptcha
    ? 'normal'
    : 'invisible';

  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
    if (this.wlUser && gdprObj) {
      this.wlUser.marketingEmailFlag = gdprObj.marketingEmailFlag;
      this.wlUser.userAgreement = gdprObj.tosEmailFlag;
    }
  }

  get passwordCondition() {
    return vxm.utility.passwordConditions;
  }

  get companyName() {
    return vxm.utility.companyName;
  }

  setShowPassword() {
    this.showPassword = !this.showPassword;
  }
  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.wlUser.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.wlUser.phoneNumberValid = event.isValid;
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }
  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }
  get globalRefCode() {
    const RefCode = vxm.referrals.globalRefCode;
    console.log('RefCode', [RefCode]);
    this.wlUser.referralUrl = RefCode;
    return RefCode;
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }


  setDefaultFontFirstName(){

setTimeout(() => {


var copiedText =   this.wlUser.firstName 
  var formattedString = copiedText.replace(/[^a-zA-Z0-9\s]/g, '');
if(formattedString.length!=copiedText.length){
  
  this.wlUser.firstName = null;

  this.$toastr(
      'error',
      this.$t('no.special.characters.allowed.firstname'),
    );

  return false;
}
return true;
}, 50);
}

setDefaultFontLastName(){
setTimeout(() => {

var copiedText =   this.wlUser.lastName



var formattedString = copiedText.replace(/[^a-zA-Z0-9\s]/g, '');
if(formattedString.length != copiedText.length){
  
  this.wlUser.lastName = null;

  this.$toastr(
      'error',
      this.$t('no.special.characters.allowed.lastname'),
    );

    return false;
  
}
return true
}, 50);
}
  verifyNames(){
    this.setDefaultFontFirstName();
 this.setDefaultFontLastName();
    }

  mounted() {
    let userParams = vxm.users.UserParams;
    this.isGDPREnabled = vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
    this.countryCode = this.getCompanyCountryCode();
    if (userParams.populateSignupPage) {
      this.candidatePhone = userParams.phone.substring(
        userParams.phone.indexOf(' ') + 1,
      );
      let dialCode = userParams.phone.substring(
        1,
        userParams.phone.indexOf(' '),
      );
      for (var i = 0; i < countries.length; i++) {
        if (countries[i].dialCode === dialCode) {
          this.countryCode = countries[i].iso2;
        }
      }
    }
  }

  get isDisabled(): boolean {
    console.log(
      'isGDPREnabled: ' +
        this.isGDPREnabled +
        ' tosEmailFlag: ' +
        !this.gdprObj.tosEmailFlag +
        ' recaptchaValue: ' +
        this.recaptchaValue,
    );
    if (this.recaptchaValue) {
      return this.isGDPREnabled && !this.gdprObj.tosEmailFlag;
    } else {
      return !this.recaptchaValue;
    }
  }

  get recaptchaValue(): boolean {
    return this.showRecaptcha ? vxm.referrals.RecaptchaResponse.success : true;
  }

  get showRecaptcha(): boolean {
    return vxm.utility.showSignUpReCaptcha;
  }
}
